import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { createPortal } from "react-dom";
import logo from "../../assets/img/logo.svg";
import "../../assets/css/general.css";

import NotificationsCenter from "../notificationsCenter";
import SettingCenter from "../settingCenter";
import AgencyCenter from "../agencySettingCenter";

const NAV_CONFIG = {
  interim: {
    links: [
      { to: "/dashboard-interim", label: "Tableau de bord" },
      { to: "/calendar", label: "Calendrier" },
      { to: "/mission-list", label: "Missions" },
      { to: "/contract-list", label: "Contrats" },
      { to: "/salary", label: "Paie" },
    ],
    panels: {
      notif: NotificationsCenter,
      settings: SettingCenter,
    },
    userLabel: "Jean Dupont",
  },
  entreprise: {
    links: [
      { to: "/dashboard", label: "Tableau de bord" },
      { to: "/calendar-entreprise", label: "Calendrier" },
      { to: "/mission-list-agency", label: "Missions" },
      { to: "/contract-list-entreprise", label: "Contrats" },
      { to: "/releve-heure", label: "Relevés" },
    ],
    panels: {
      notif: NotificationsCenter,
      settings: AgencyCenter,
    },
    userLabel: "ACME Corp.",
  },
};

export default function NavBarApp({ userType = "interim" }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [activePanel, setActivePanel] = useState(null);

  const { links, panels, userLabel } = NAV_CONFIG[userType];

  const toggleMenu = () => {
    if (menuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setMenuOpen(false);
        setIsClosing(false);
      }, 300); // durée = animation CSS
    } else {
      setMenuOpen(true);
    }
  };

  useEffect(() => {
    document.body.style.overflow =
      (menuOpen || activePanel) && !isClosing ? "hidden" : "auto";
  }, [menuOpen, isClosing, activePanel]);

  const openPanel = (key) =>
    setActivePanel((prev) => (prev === key ? null : key));

  return (
    <>
      <section className="nav-app-section">
        <button
          className={`burger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>

        <div className="right-nav-app">
          <Link to="/#" className="nav-app-logo">
            <img src={logo} alt="logo" width="50" />
          </Link>
          {links.map(({ to, label }) => (
            <Link key={to} className="nav-app-links" to={to}>
              {label}
            </Link>
          ))}
        </div>

        <div className="left-nav-app">
          <div className="nav-app-icon" onClick={() => openPanel("notif")}>
            <i className="fa-regular fa-bell" style={{ color: "#18c3ba" }} />
          </div>
          <div
            className="nav-app-profil"
            onClick={() => openPanel("settings")}
            style={{ cursor: "pointer" }}
          >
            {userLabel}
          </div>
        </div>

        <div
          className={`mobile-menu ${
            menuOpen ? "open" : isClosing ? "closing" : ""
          }`}
        >
          {links.map(({ to, label }) => (
            <Link
              key={to}
              className="nav-app-links"
              to={to}
              onClick={toggleMenu}
            >
              {label}
            </Link>
          ))}
        </div>
      </section>

      {/* Sidebar dynamique */}
      {activePanel &&
        panels[activePanel] &&
        createPortal(
          React.createElement(panels[activePanel], {
            isOpen: true,
            onClose: () => setActivePanel(null),
          }),
          document.body
        )}
    </>
  );
}
